export const CREATE_PALLET_ISSUE = 'CREATE_PALLET_ISSUE';
export const GET_PALLET_ISSUE = 'GET_PALLET_ISSUE';
export const PALLET_ISSUE_REQUEST = 'PALLET_ISSUE_REQUEST';
export const PALLET_ISSUE_REQUEST_SUCCESS = 'PALLET_ISSUE_REQUEST_SUCCESS';
export const UPDATE_PALLET_ISSUE = 'UPDATE_PALLET_ISSUE';
export const DELETE_PALLET_ISSUE = 'DELETE_PALLET_ISSUE';
export const PALLET_ISSUE_REQUEST_FAILURE = 'PALLET_ISSUE_REQUEST_FAILURE';
export const GET_PALLET_ISSUES_PAGE = 'GET_PALLET_ISSUES_PAGE';

